/** UI components, images, audit, login, and remaining error strings. */

export const miscUiMessagesTh: Record<string, string> = {
  // —— Shared UI ——
  'ui.select.placeholder': 'เลือก...',
  'ui.multiSelect.placeholder': 'เลือกรายการ...',
  'ui.multiSelect.selected': 'เลือกแล้ว {count} รายการ',
  'ui.datePicker.placeholder': 'เลือกวันที่',
  'ui.datePicker.today': 'วันนี้',
  'ui.datePicker.clear': 'ล้าง',
  'ui.datePicker.prevMonth': 'เดือนก่อน',
  'ui.datePicker.nextMonth': 'เดือนถัดไป',
  'ui.emptyState.title': 'ยังไม่มีข้อมูล',
  'ui.emptyState.description': 'รายการจะแสดงที่นี่เมื่อมีข้อมูล',
  'ui.errorState.title': 'โหลดข้อมูลไม่สำเร็จ',
  'ui.errorState.message': 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
  'ui.errorState.retry': 'ลองใหม่',
  'ui.permissionGate.label': 'ไม่มีสิทธิ์',
  'ui.permissionGate.title': 'คุณไม่มีสิทธิ์ใช้งานฟีเจอร์นี้',
  'ui.colorPicker.auto': 'อัตโนมัติ',
  'ui.colorPicker.custom': 'กำหนดเอง',

  'ui.notificationCenter.ariaLabel': 'การแจ้งเตือน',
  'ui.notificationCenter.title': 'การแจ้งเตือน',
  'ui.notificationCenter.markAllRead': 'อ่านทั้งหมดแล้ว',
  'ui.notificationCenter.loading': 'กำลังโหลด...',
  'ui.notificationCenter.empty': 'ไม่มีการแจ้งเตือน',

  'ui.commandPalette.placeholder': 'ค้นหาเมนู งาน รายการเงิน...',
  'ui.commandPalette.searching': 'กำลังค้นหา...',
  'ui.commandPalette.noResults': 'ไม่พบผลลัพธ์',
  'ui.commandPalette.refreshCurrent': 'รีเฟรชหน้าปัจจุบัน',
  'ui.commandPalette.hintRefresh': 'Ctrl+R',
  'ui.commandPalette.hintProjectTask': 'งานโปรเจกต์',
  'ui.commandPalette.hintIncome': 'รายรับ',
  'ui.commandPalette.hintExpense': 'รายจ่าย',
  'ui.commandPalette.hintChangelog': 'แพตช์โน้ต',

  'ui.onboardingTour.progress': 'ขั้นตอน',
  'ui.onboardingTour.skip': 'ข้าม',
  'ui.onboardingTour.next': 'ถัดไป',
  'ui.onboardingTour.start': 'เริ่มใช้งาน',
  'ui.onboardingTour.step1.title': 'แดชบอร์ดภาพรวม',
  'ui.onboardingTour.step1.body': 'ดูสถิติ การเงิน งานด่วน และกิจกรรมที่กำลังจะมาถึงได้ที่นี่',
  'ui.onboardingTour.step2.title': 'บอร์ดโปรเจกต์',
  'ui.onboardingTour.step2.body': 'จัดการงานทีม ลากการ์ดเปลี่ยนสถานะ และติดตามความคืบหน้า',
  'ui.onboardingTour.step3.title': 'งานของฉัน',
  'ui.onboardingTour.step3.body': 'งานส่วนตัวและงานที่ได้รับมอบหมายจากโปรเจกต์ — เห็นเฉพาะของคุณ',
  'ui.onboardingTour.step4.title': 'ตั้งค่าระบบ',
  'ui.onboardingTour.step4.body': 'ปรับธีม ภาษา และการแจ้งเตือนตามต้องการ',

  // —— Images & CDN ——
  'images.resizerTitle': 'ย่อ/ปรับขนาดรูป',
  'images.cdnTitle': 'รูปที่ฝากไว้ (CDN)',
  'images.uploadPrompt': 'ลากไฟล์มาวาง หรือคลิกเพื่อเลือก',
  'images.uploadFormats': 'PNG, JPG, GIF, WebP, AVIF — สูงสุด 10 MB',
  'images.changeImage': 'เปลี่ยนรูป',
  'images.originalSize': 'ขนาดต้นฉบับ:',
  'images.presetSizes': 'ขนาดสำเร็จรูป',
  'images.presetOriginal': 'ขนาดเดิม',
  'images.presetDiscordAvatar': 'Discord Avatar (128×128)',
  'images.presetProfilePic': 'Profile Pic (256×256)',
  'images.presetDiscordBanner': 'Discord Banner (960×540)',
  'images.presetCoverMeta': 'Cover/Meta (1200×630)',
  'images.presetFullHd': 'Full HD (1920×1080)',
  'images.width': 'ความกว้าง',
  'images.height': 'ความสูง',
  'images.maintainRatio': 'รักษาอัตราส่วน',
  'images.fileFormat': 'รูปแบบไฟล์',
  'images.quality': 'คุณภาพ',
  'images.process': 'ประมวลผล',
  'images.processSuccess': 'ประมวลผลรูปสำเร็จ',
  'images.processedReady': 'รูปพร้อมใช้งาน',
  'images.downloadLocal': 'ดาวน์โหลด',
  'images.hostCdn': 'ฝาก CDN',
  'images.uploadOriginal': 'ฝาก CDN (ไฟล์ต้นฉบับ — แนะนำสำหรับ Discord)',
  'images.discordQualityHint':
    'ลิงก์ Discord แนะนำใช้ไฟล์ต้นฉบับ — การย่อ/แปลง JPEG จะทำให้สีเพี้ยนและภาพแตกเพราะ Discord บีบซ้ำอีกรอบ',
  'images.uploadSuccess': 'อัปโหลดสำเร็จ',
  'images.uploadError': 'อัปโหลดไม่สำเร็จ',
  'images.linkCopied': 'คัดลอกลิงก์แล้ว',
  'images.linkCopyFailed': 'คัดลอกลิงก์ไม่สำเร็จ',
  'images.copyLink': 'คัดลอกลิงก์',
  'images.deleteImage': 'ลบรูป',
  'images.editName': 'แก้ไขชื่อ',
  'images.namePlaceholder': 'ชื่อรูป',
  'images.renameSuccess': 'เปลี่ยนชื่อแล้ว',
  'images.confirmDelete': 'ต้องการลบรูปนี้ใช่หรือไม่?',
  'images.deleted': 'ลบรูปแล้ว',
  'images.size': 'ขนาด',
  'images.emptyTitle': 'ยังไม่มีรูปที่ฝากไว้',
  'images.emptyDesc': 'ประมวลผลและฝากรูปเพื่อใช้ลิงก์ CDN',
  'images.bytes.zero': '0 Bytes',

  // —— Audit log ——
  'audit.title': 'Audit Log',
  'audit.colUser': 'ผู้ใช้',
  'audit.colAction': 'การกระทำ',
  'audit.colTarget': 'เป้าหมาย',
  'audit.colDetails': 'รายละเอียด',
  'audit.colTime': 'เวลา',
  'audit.refresh': 'รีเฟรช',
  'audit.noProfile': 'ไม่มีโปรไฟล์',
  'audit.emptyTitle': 'ยังไม่มีบันทึก',
  'audit.emptyDesc': 'การกระทำในระบบจะถูกบันทึกที่นี่',
  'audit.showing': 'แสดง',
  'audit.of': 'จาก',
  'audit.items': 'รายการ',
  'audit.prev': 'ก่อนหน้า',
  'audit.next': 'ถัดไป',
  'audit.jumpTitle': 'ไปหน้า (1–{total})',
  'audit.jumpHint': 'กด Enter เพื่อไป',

  // —— Login ——
  'login.title': 'เข้าสู่ระบบ',
  'login.subtitle': 'ใช้บัญชี Discord ของคุณเพื่อเข้าใช้งาน',
  'login.tagline': 'ศูนย์บัญชาการ\nจัดการเซิร์ฟเวอร์ FiveM',
  'login.featureServer': 'จัดการทีมงาน & เซิร์ฟเวอร์',
  'login.featureFinance': 'ระบบการเงิน & งบประมาณ',
  'login.featureCalendar': 'ปฏิทิน & กิจกรรม',
  'login.featureAudit': 'Audit Log & ความปลอดภัย',
  'login.copyright': '© XG-Hub — FiveM Command Center',
  'login.discordButton': 'เข้าสู่ระบบด้วย Discord',
  'login.errorDefault': 'เข้าสู่ระบบไม่สำเร็จ กรุณาลองใหม่',
  'login.error.no_code': 'ไม่พบรหัสยืนยันจาก Discord',
  'login.error.invalid_state': 'การยืนยันตัวตนไม่ถูกต้อง กรุณาลองใหม่',
  'login.error.token_exchange': 'แลกโทเค็น Discord ไม่สำเร็จ',
  'login.error.user_fetch': 'ดึงข้อมูลผู้ใช้ Discord ไม่สำเร็จ',
  'login.error.not_in_guild': 'บัญชีของคุณไม่อยู่ใน Discord Server ที่กำหนด',
  'login.error.access_denied': 'บัญชีของคุณไม่มีสิทธิ์เข้าใช้งาน — ตรวจสอบ Role ใน Discord',
  'login.diagnosticsTitle': 'ข้อมูลวินิจฉัย',
  'login.discordUserId': 'Discord User ID:',
  'login.yourRoles': 'Role ของคุณ:',
  'login.noRoles': 'ไม่มี Role',
  'login.envHint': 'ค่า Role ที่ระบบคาดหวัง (จาก .env):',
  'login.notConfigured': 'ยังไม่ได้ตั้งค่า',

  // —— Server errors (remaining) ——
  'errors.projectNameRequired': 'กรุณาระบุชื่อโปรเจกต์',
  'errors.subtaskTitleRequired': 'กรุณาระบุชื่อรายการย่อย',
  'errors.taskNotFound': 'ไม่พบงาน',
  'errors.invalidColor': 'รูปแบบสีไม่ถูกต้อง',
  'errors.invalidFileFormat': 'รูปแบบไฟล์ไม่ถูกต้อง (ต้องเป็น data URL แบบ base64)',
  'errors.imagesOnly': 'อนุญาตเฉพาะไฟล์รูปภาพ (PNG, JPG, GIF, WebP, AVIF)',
  'errors.fileTooLarge': 'ขนาดไฟล์ต้องไม่เกิน 10 MB',
  'errors.invalidCategoryType': 'ประเภทหมวดหมู่ไม่ถูกต้อง',
  'errors.categoryExists': 'มีหมวดหมู่นี้อยู่แล้ว',
  'errors.categoryNotFound': 'ไม่พบหมวดหมู่',
  'errors.invalidSlipFormat': 'รูปแบบไฟล์สลิปไม่ถูกต้อง (ต้องเป็น data URL แบบ base64)',
  'errors.slipImagesOnly': 'อนุญาตเฉพาะไฟล์รูปภาพสลิป (PNG, JPG, GIF, WebP, AVIF)',
  'errors.slipTooLarge': 'ขนาดไฟล์สลิปต้องไม่เกิน 10 MB',
  'errors.invalidAccountType': 'ประเภทบัญชีไม่ถูกต้อง (ต้องเป็น income หรือ expense)',
  'errors.amountPositive': 'จำนวนเงินต้องเป็นตัวเลขมากกว่า 0',
  'errors.invalidTransactionDate': 'วันที่ทำรายการไม่ถูกต้อง',
  'errors.categoryRequired': 'กรุณาระบุหมวดหมู่',
  'errors.slipExpenseOnly': 'แนบสลิปได้เฉพาะรายจ่ายเท่านั้น',
  'errors.transactionNotFound': 'ไม่พบรายการธุรกรรม',
  'errors.itemTitleRequired': 'กรุณาระบุชื่อรายการ',
  'errors.categorySelectRequired': 'กรุณาเลือกหมวดหมู่',
  'errors.invalidDayOfMonth': 'วันที่ครบกำหนดต้องอยู่ระหว่าง 1–31',
  'errors.itemNotFound': 'ไม่พบรายการ',
  'errors.itemInactive': 'รายการนี้ถูกปิดใช้งาน',
  'errors.alreadyRecordedThisMonth': 'บันทึกรายการนี้ในเดือนนี้แล้ว',
  'errors.invalidShare': 'ส่วนแบ่งต้องเป็นตัวเลขระหว่าง 0 ถึง 100',
  'errors.imageNameRequired': 'กรุณาระบุชื่อรูป',
  'errors.imageNotFound': 'ไม่พบรูปภาพ',
  'errors.invalidTaskStatus': 'สถานะงานไม่ถูกต้อง: {status}',
  'errors.categoryInUse': 'ไม่สามารถลบได้ — มี {count} รายการที่ใช้หมวดหมู่นี้อยู่',
  'errors.settingNotAllowed': 'ไม่อนุญาตให้แก้ไขการตั้งค่า: {key}',
  'errors.shareTotalExceeded': 'ไม่สามารถกำหนดส่วนแบ่งได้รวมกันเกิน 100% (เซิร์ฟเวอร์ {serverShare}%, ทีมงานคนอื่น {otherTotal}%)',
};

export const miscUiMessagesEn: Record<string, string> = {
  'ui.select.placeholder': 'Select...',
  'ui.multiSelect.placeholder': 'Select items...',
  'ui.multiSelect.selected': '{count} selected',
  'ui.datePicker.placeholder': 'Pick a date',
  'ui.datePicker.today': 'Today',
  'ui.datePicker.clear': 'Clear',
  'ui.datePicker.prevMonth': 'Previous month',
  'ui.datePicker.nextMonth': 'Next month',
  'ui.emptyState.title': 'Nothing here yet',
  'ui.emptyState.description': 'Items will show up here when available',
  'ui.errorState.title': 'Failed to load',
  'ui.errorState.message': 'Something went wrong. Please try again.',
  'ui.errorState.retry': 'Retry',
  'ui.permissionGate.label': 'No access',
  'ui.permissionGate.title': 'You do not have permission for this feature',
  'ui.colorPicker.auto': 'Auto',
  'ui.colorPicker.custom': 'Custom',

  'ui.notificationCenter.ariaLabel': 'Notifications',
  'ui.notificationCenter.title': 'Notifications',
  'ui.notificationCenter.markAllRead': 'Mark all read',
  'ui.notificationCenter.loading': 'Loading...',
  'ui.notificationCenter.empty': 'No notifications',

  'ui.commandPalette.placeholder': 'Search menus, tasks, transactions...',
  'ui.commandPalette.searching': 'Searching...',
  'ui.commandPalette.noResults': 'No results',
  'ui.commandPalette.refreshCurrent': 'Refresh current page',
  'ui.commandPalette.hintRefresh': 'Ctrl+R',
  'ui.commandPalette.hintProjectTask': 'Project task',
  'ui.commandPalette.hintIncome': 'Income',
  'ui.commandPalette.hintExpense': 'Expense',
  'ui.commandPalette.hintChangelog': 'Patch note',

  'ui.onboardingTour.progress': 'Step',
  'ui.onboardingTour.skip': 'Skip',
  'ui.onboardingTour.next': 'Next',
  'ui.onboardingTour.start': 'Get started',
  'ui.onboardingTour.step1.title': 'Overview dashboard',
  'ui.onboardingTour.step1.body': 'See stats, finances, urgent tasks, and upcoming events at a glance.',
  'ui.onboardingTour.step2.title': 'Project board',
  'ui.onboardingTour.step2.body': 'Manage team work, drag cards to update status, and track progress.',
  'ui.onboardingTour.step3.title': 'My tasks',
  'ui.onboardingTour.step3.body': 'Personal tasks and assignments from projects — visible only to you.',
  'ui.onboardingTour.step4.title': 'Settings',
  'ui.onboardingTour.step4.body': 'Adjust theme, language, and notifications to your preference.',

  'images.resizerTitle': 'Resize',
  'images.cdnTitle': 'Hosted images',
  'images.uploadPrompt': 'Drop a file here or click to browse',
  'images.uploadFormats': 'PNG, JPG, GIF, WebP, AVIF — max 10 MB',
  'images.changeImage': 'Change image',
  'images.originalSize': 'Original:',
  'images.presetSizes': 'Presets',
  'images.presetOriginal': 'Original size',
  'images.presetDiscordAvatar': 'Discord avatar (128×128)',
  'images.presetProfilePic': 'Profile pic (256×256)',
  'images.presetDiscordBanner': 'Discord banner (960×540)',
  'images.presetCoverMeta': 'Cover/meta (1200×630)',
  'images.presetFullHd': 'Full HD (1920×1080)',
  'images.width': 'Width',
  'images.height': 'Height',
  'images.maintainRatio': 'Keep aspect ratio',
  'images.fileFormat': 'Format',
  'images.quality': 'Quality',
  'images.process': 'Process',
  'images.processSuccess': 'Image processed',
  'images.processedReady': 'Ready',
  'images.downloadLocal': 'Download',
  'images.hostCdn': 'Upload to CDN',
  'images.uploadOriginal': 'Upload original (best for Discord)',
  'images.discordQualityHint':
    'For Discord links, upload the original file. Resize/JPEG export shifts colors and can look blocky after Discord recompresses again.',
  'images.uploadSuccess': 'Upload complete',
  'images.uploadError': 'Upload failed',
  'images.linkCopied': 'Link copied',
  'images.linkCopyFailed': 'Failed to copy link',
  'images.copyLink': 'Copy link',
  'images.deleteImage': 'Delete',
  'images.editName': 'Rename',
  'images.namePlaceholder': 'Image name',
  'images.renameSuccess': 'Renamed',
  'images.confirmDelete': 'Delete this image?',
  'images.deleted': 'Image deleted',
  'images.size': 'Size',
  'images.emptyTitle': 'No hosted images',
  'images.emptyDesc': 'Process and upload images to get CDN links',
  'images.bytes.zero': '0 B',

  'audit.title': 'Audit log',
  'audit.colUser': 'User',
  'audit.colAction': 'Action',
  'audit.colTarget': 'Target',
  'audit.colDetails': 'Details',
  'audit.colTime': 'Time',
  'audit.refresh': 'Refresh',
  'audit.noProfile': 'No profile',
  'audit.emptyTitle': 'No records yet',
  'audit.emptyDesc': 'System actions will be logged here',
  'audit.showing': 'Showing',
  'audit.of': 'of',
  'audit.items': 'items',
  'audit.prev': 'Previous',
  'audit.next': 'Next',
  'audit.jumpTitle': 'Go to page (1–{total})',
  'audit.jumpHint': 'Press Enter to go',

  'login.title': 'Sign in',
  'login.subtitle': 'Use your Discord account to continue',
  'login.tagline': 'FiveM server\ncommand center',
  'login.featureServer': 'Team & server management',
  'login.featureFinance': 'Finance & budgets',
  'login.featureCalendar': 'Calendar & events',
  'login.featureAudit': 'Audit log & security',
  'login.copyright': '© XG-Hub — FiveM Command Center',
  'login.discordButton': 'Continue with Discord',
  'login.errorDefault': 'Sign-in failed. Please try again.',
  'login.error.no_code': 'No authorization code from Discord',
  'login.error.invalid_state': 'Invalid auth state. Please try again.',
  'login.error.token_exchange': 'Failed to exchange Discord token',
  'login.error.user_fetch': 'Failed to fetch Discord profile',
  'login.error.not_in_guild': 'Your account is not in the configured Discord server',
  'login.error.access_denied': 'Access denied — check your Discord roles',
  'login.diagnosticsTitle': 'Diagnostics',
  'login.discordUserId': 'Discord user ID:',
  'login.yourRoles': 'Your roles:',
  'login.noRoles': 'No roles',
  'login.envHint': 'Expected roles (from .env):',
  'login.notConfigured': 'Not configured',

  'errors.projectNameRequired': 'Project name is required',
  'errors.subtaskTitleRequired': 'Subtask title is required',
  'errors.taskNotFound': 'Task not found',
  'errors.invalidColor': 'Invalid color format',
  'errors.invalidFileFormat': 'Invalid file format (must be base64 data URL)',
  'errors.imagesOnly': 'Only image files allowed (PNG, JPG, GIF, WebP, AVIF)',
  'errors.fileTooLarge': 'File must be 10 MB or smaller',
  'errors.invalidCategoryType': 'Invalid category type',
  'errors.categoryExists': 'Category already exists',
  'errors.categoryNotFound': 'Category not found',
  'errors.invalidSlipFormat': 'Invalid slip format (must be base64 data URL)',
  'errors.slipImagesOnly': 'Only slip image files allowed (PNG, JPG, GIF, WebP, AVIF)',
  'errors.slipTooLarge': 'Slip file must be 10 MB or smaller',
  'errors.invalidAccountType': 'Invalid account type (must be income or expense)',
  'errors.amountPositive': 'Amount must be a number greater than 0',
  'errors.invalidTransactionDate': 'Invalid transaction date',
  'errors.categoryRequired': 'Category is required',
  'errors.slipExpenseOnly': 'Slips can only be attached to expenses',
  'errors.transactionNotFound': 'Transaction not found',
  'errors.itemTitleRequired': 'Item title is required',
  'errors.categorySelectRequired': 'Please select a category',
  'errors.invalidDayOfMonth': 'Due day must be between 1 and 31',
  'errors.itemNotFound': 'Item not found',
  'errors.itemInactive': 'This item is inactive',
  'errors.alreadyRecordedThisMonth': 'Already recorded this month',
  'errors.invalidShare': 'Share must be a number between 0 and 100',
  'errors.imageNameRequired': 'Image name is required',
  'errors.imageNotFound': 'Image not found',
  'errors.invalidTaskStatus': 'Invalid task status: {status}',
  'errors.categoryInUse': 'Cannot delete — {count} transaction(s) use this category',
  'errors.settingNotAllowed': 'Setting cannot be changed: {key}',
  'errors.shareTotalExceeded': 'Total share cannot exceed 100% (server {serverShare}%, other staff {otherTotal}%)',
};
